/**
 * 模拟考试卡片
 */
export default {
  difficulty: 'Difficulty',
  mockDuration: 'Mock Duration',
  intro: 'Brief introduction',
}
